export default [
  {
    id: 1,
    content: "전조등, 후미등, 방향지시기 및 후진경보장치, 경광등의 정상작동여부를 정기적으로 점검한다.",
    isChecked: "",
  },
  {
    id: 2,
    content: "백레스트 및 헤드가드가 파손되지 않았다.",
    isChecked: "",
  },
  {
    id: 3,
    content: "지게차 운전원의 자격을 확인하고, 지정된 자가 운전하도록 관리한다.",
    isChecked: "",
  },
  {
    id: 4,
    content: "지게차 운전원에게 작업방법, 작업 순서, 운행 경로 등에 관한 내용을 교육한다.",
    isChecked: "",
  },
  {
    id: 5,
    content: "지게차 운전시 운전원이 안전벨트를 착용하도록 한다.",
    isChecked: "",
  },
  {
    id: 6,
    content: "지게차에 화물을 적재할 경우에는 운전원의 시야를 가리지 않도록 한다.",
    isChecked: "",
  },
  {
    id: 7,
    content: "지게차 작업 반경 내에 다른 작업자가 이동하지 않도록 한다.",
    isChecked: "",
  },
  {
    id: 8,
    content: "작업장을 이동할 때 제한속도를 지정하였다.",
    isChecked: "",
  },
  {
    id: 9,
    content: "후진, 회전 등 장비 이동 시에 근로자 충돌방지를 위한 후진경보기와 경광등 혹은 후방감지기를 갖추었다.",
    isChecked: "",
  },
  {
    id: 10,
    content: "지게차 허용하중을 초과하여 적재하지 않는다.",
    isChecked: "",
  },
  {
    id: 11,
    content: "지게차 운행중에 적재한 화물이 떨어지지 않도록 고정한다.",
    isChecked: "",
  },
  {
    id: 12,
    content: "하역운반 작업장 바닥은 평탄하고 견고한 곳으로 별도로 지정한다.",
    isChecked: "",
  },
  {
    id: 13,
    content: "지게차 작업장 이동경로에 적재물을 방치하지 않는다.",
    isChecked: "",
  },
  {
    id: 14,
    content: "작업 종료 후 지게차 열쇠는 별도 관리하고 있다.",
    isChecked: "",
  },
];
